import { DOT_ROOT_CLASS, inject, Injection, UNDERLINE_ROOT_CLASS } from './Injection';

/**
 * Injects both the dot and the underline roots right below the root HTML tag.
 */
export class GenericInjection implements Injection {
    private static QUERY_SELECTOR = 'html';

    constructor(private readonly document: HTMLDocument) {}

    injectUnderlineRoot(): HTMLElement {
        return inject(this.document, UNDERLINE_ROOT_CLASS, GenericInjection.QUERY_SELECTOR);
    }

    injectDotRoot(): HTMLElement {
        return inject(this.document, DOT_ROOT_CLASS, GenericInjection.QUERY_SELECTOR);
    }
}
